import React from 'react';
import {clear} from "@testing-library/user-event/dist/clear";

function BackedItem(props) {
    const {id, name, price, quantity, incrementQuantity, decrQuantity} = props;

    return (
        <li className="collection-item">
            {name} x{quantity} = {price * quantity}<b>$</b>
            <span className="secondary-content">
               <a className="waves-effect waves-light btn btnq" onClick={() => incrementQuantity(id)}>
                   <i className="material-icons left">exposure_plus_1</i>add</a>
                  <a className="waves-effect waves-light btn btnq" onClick={() => decrQuantity(id)}
                  style={{margin: '0px 10px'}}>
                     <i className="material-icons left">exposure_minus_1</i>remove</a>
                        <a className="waves-effect waves-light btn btnq"
                           onClick={() => props.removeBacked(id)}
                        >
                             <i className="material-icons basket-delete">delete_forever</i>
                        </a>

            </span>

        </li>
    );
}

export default BackedItem;